module.exports = __webpack_public_path__ + "static/media/Nabuqi--A-View-Beyond-Space--No-5.31176ed0.jpg";